export const languages = [
  { value: "en-GB", name: "English" },
  { value: "en-CA", name: "English Canada", countryCode: "CAN" },
  { value: "en-AU" },
  { value: "en-IN" },
  { value: "ja", name: "日本語" },
  { value: "sv", name: "Svenska" },
  { value: "no", name: "Norsk" },
  { value: "tr", name: "Türkçe" },
  { value: "pt-BR", name: "Português Brasil", flagId: "pt-br" },
  { value: "pt", name: "Português" },
  { value: "ru", name: "Русский" },
  { value: "ru-RU" },
  { value: "ru-UA" },
  { value: "uk", name: "Українська" },
  { value: "zh", name: "中文" },
  { value: "zh-Hant", countryCode: 'TWN' },
  { value: "de", name: "Deutsch" },
  { value: "es", name: "Español" },
  { value: "es-MX", name: "Español Mexico", countryCode: "MEX" },
  { value: "fi", name: "Suomi" },
  { value: "fr", name: "Français" },
  { value: "fr-CA", name: "Français Canada", countryCode: "CAN" },
  { value: "es-419" },
  { value: "it" },
  { value: "fa", name: "فارسی" },
  { value: "pl", name: "Polski" },
  { value: "ro", name: "Română" },
  { value: "bg" },
  { value: "ar", name: "العربية" },
  { value: "th", name: "ภาษาไทย" },
  { value: "hi", name: "हिन्दी" },
  { value: "he" },
  { value: "hy" },
  { value: "vi", name: "Tiếng Việt" },
  { value: "ko", name: "한국어" },
  { value: "ms" },
  { value: "my" },
  { value: "mr" },
  { value: "id", name: "Bahasa Indonesia" },
  { value: "fil" },
  { value: "kk", name: "Қазақ тілі" },
  { value: "az" },
  { value: "kn" },
  { value: "bn" },
  { value: "te" },
  { value: "da" },
  { value: "nl" },
  { value: "ur", name: "اُردُو" },
  { value: "chr" },
  { value: "en-x-sweepstk" },
];

export const presentationLanguages = [
  "en-GB",
  "en-CA",
  "ja",
  "sv",
  "no",
  "tr",
  "pt",
  "pt-BR",
  "es",
  "es-MX",
  "fi",
  "fr",
  "fr-CA",
  "ru",
  "uk",
  "hi",
  "pl",
  "de",
  "ro",
  "id",
  "kk",
  "th",
  "vi",
  "ko",
  "ar",
  "fa",
  "ur",
  "zh",
];

const getLangConfig = (lang) => {
  return languages.find((l) => l.value.toLowerCase() === lang.toLowerCase());
};

export const getLanguageFlagName = (lang) => {
  const langConfig = getLangConfig(lang);

  if (langConfig && langConfig.countryCode) {
    return `https://files-immutable-4cbc033nbd3.sptpub.com/flags_by_code/${langConfig.countryCode}.svg`
  }

  return langConfig
    ? `/static/flags/${
        langConfig.flagId || langConfig.value.toLowerCase().split("-")[0]
      }.svg`
    : null;
};

export const getLanguageName = (lang) => {
  const langConfig = getLangConfig(lang);
  return langConfig && langConfig.name
    ? langConfig.name.toUpperCase()
    : lang.toUpperCase();
};
